



























































































import {
  computed,
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import {
  ProductCategoryAttribute,
  ProductCategoryAttributeType,
} from '@/models/entities/ProductCategoryAttribute';

interface Props {
  id: string;
}

interface State {
  entity: ProductCategoryAttribute;
  loading: boolean;
}

const Component = defineComponent({
  name: 'ProductCategoryAttributesDialog',

  components: {
    EntityDialog,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let productCategoryAttribute = new ProductCategoryAttribute({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(
          `productCategoryAttributesModule/fetchItem`,
          props.id,
        );
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: productCategoryAttribute,
      loading: computed(() => $store.getters['productCategoryAttributesModule/loading']),
    }) as State;

    watch(
      () => $store.getters['productCategoryAttributesModule/selectedItem'],
      (newValue: ProductCategoryAttribute) =>
        Object.assign(productCategoryAttribute, newValue),
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Product Category Attribute';
      return `Edit Product Category Attribute`;
    });

    const rules = {
      title: [(v: string) => !!v || 'Title is required'],
      number: [
        (v: any) => {
          if (v === '') return 'Provide correct default value';
          const number = parseInt(v);
          if (
            state.entity.type === ProductCategoryAttributeType.NUMBER &&
            number !== 0 &&
            !number
          )
            return 'Default value should have selected Type';
          return true;
        },
        (v: number) => v < 10000 || 'Number couldn`t be longer than 3 digits',
        (v: number) => v >= 0 || 'Only positive numbers allowed',
      ],
    };
    const productCategoryAttributeType = Object.values<ProductCategoryAttributeType>(
      ProductCategoryAttributeType,
    );

    return {
      state,
      title,
      rules,
      isNew,
      productCategoryAttributeType,
      ProductCategoryAttributeType,
    };
  },
});
export default Component;
